import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';

type Props = {
  onClick: () => void;
};

const LegalGuaranteeLink = forwardRef<HTMLButtonElement, Props>(({ onClick }, ref) => {
  const { t } = useTranslation(['product']);

  return (
    <button
      aria-haspopup="dialog"
      className="caption w-fit text-left underline"
      onClick={onClick}
      ref={ref}
      type="button"
    >
      {t('productPanel.legalGuarantee.link', { ns: 'product' })}
    </button>
  );
});

LegalGuaranteeLink.displayName = 'LegalGuaranteeLink';

export default LegalGuaranteeLink;
